import { PageContentLoader } from '@components/cms';
import { lazy, Suspense } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
const ExamplePage = lazy(() =>
  import('@components/pages/ExamplePage/ExamplePage').then((module) => ({
    default: module.ExamplePage,
  }))
);

export const Routes = () => {
  const router = createBrowserRouter([
    // Example page created in React
    {
      path: 'example',
      element: (
        <Suspense fallback={null}>
          <ExamplePage />
        </Suspense>
      ),
    },
    // This is catch-all component for EPI Content Pages
    // It will catch all other URLs and try to map it to the EPI components
    {
      path: '/*',
      element: <PageContentLoader />,
    },
  ]);
  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  );
};
